import React from "react";
import { Portfolio } from "../../../../../graphql/generated";
import {
  ResumeCard,
  ResumeEducations,
  ResumeExperiences,
  ResumeLeft,
  ResumeRight,
  ResumeSectionWrapper,
} from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const ResumeSection: React.FC<Props> = ({ portfolioData }) => {
  return (
    <ResumeSectionWrapper>
      <ResumeLeft>
        <ResumeEducations>
          <h1>My Educations...</h1>

          {portfolioData?.resume?.educations?.map?.((item) => (
            <ResumeCard key={item?.id || ""}>
              <h1>{item?.institute || ""}</h1>
              <h4>
                {item?.startDate || ""} - {item?.endDate || ""} |{" "}
                {item?.location || ""}
              </h4>
              {item?.description && <p>{item.description}</p>}
            </ResumeCard>
          ))}
        </ResumeEducations>

        <ResumeExperiences>
          <h1>My Experiences...</h1>

          {portfolioData?.resume?.experiences?.map?.((item) => (
            <ResumeCard key={item?.id || ""}>
              <h1>{item?.designation || ""}</h1>
              <h4>
                {item?.startDate || ""} - {item?.endDate || ""} |{" "}
                {item?.company || ""}
              </h4>
              {item?.description && item.description !== "..." && (
                <p>{item.description}</p>
              )}
            </ResumeCard>
          ))}
        </ResumeExperiences>
      </ResumeLeft>

      <ResumeRight />
    </ResumeSectionWrapper>
  );
};

export default ResumeSection;
